import "./VisitUs.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { IoIosArrowRoundForward } from "react-icons/io";
import { SlCalender } from "react-icons/sl";
import { MdOutlineBook } from "react-icons/md";
import { HiOutlineAcademicCap } from "react-icons/hi";
import { Link } from "react-router-dom";

const VisitUs = () => {
  const lines = Array.from({ length: 3 });

  return (
    <div className="visit-us">
      <div className="gray-box">
        <div className="visit-header-parent">
          <h2 className="white">VISIT US</h2>
          <div className="visit-code" style={styles.container}>
            {lines.map((_, index) => (
              <div key={index} style={styles.line}></div>
            ))}
          </div>
        </div>

        <div className="center-white-box">
          <div className="green-white-box ">
            <div className="white-box1 grid-border-radius1 visit-hover1">
              <SlCalender className="admission-icon green" size={70} />
              <h2 className="green admission-heading visit-head">Admission</h2>
              <p>
                Noorul Islam College of Arts & Science Admission opens for
                2025-2026 academic year. Our college stepping towards the 25th,
                year of journey.
              </p>
              <hr className="visit-hr-line" />
              <div className="know-arrow link-underline-remove">
                <Link
                  className="green content-arrow"
                  to="/Admission/Application_For_Admission"
                >
                  Know More
                </Link>
                <span>
                  <IoIosArrowRoundForward size={30} className="visit-arrow" />
                </span>
              </div>
            </div>

            <div className="gray-green-box visit-hover2">
              <MdOutlineBook className="book green" size={70} />
              <h2 className="academics-heading visit-head">Career Guidance</h2>
              <p className="visit-para-width">
                Career Guidance for all students are scheduled based on Skill
                development courses, all the Final Year students are
                participating in InCampus & motivated to attend Off Campus
                placements.
              </p>
              <hr className="visit-hr-line" />
              <div className="know-arrow link-underline-remove">
                <Link
                  className="green content-arrow"
                  to="/Campus_Life/Placement_and_Career/Inhouse_Training"
                >
                  Know More
                </Link>
                <span>
                  <IoIosArrowRoundForward size={30} className="visit-arrow" />
                </span>
              </div>
            </div>

            <div className="white-box2 grid-border-radius2 visit-hover3">
              <HiOutlineAcademicCap class="green academics" size={70} />
              <h2 className="academics-heading visit-head">Academics</h2>
              <p className="academics-para">
                It started in July 2001 with 75 students in three undergraduate
                courses: Computer Science, Computer Application, and Information Technology.
                Affiliated with Manonmaniam Sundaranar University, Tirunelveli, we aim to develop
                quality leaders who serve the society.
              </p>
              <hr className="visit-hr-line" />
              <div className="know-arrow link-underline-remove">
                <Link
                  className="green content-arrow"
                  to="/academics/curriculum-and-syllabus"
                >
                  Know More
                </Link>

                <span>
                  <IoIosArrowRoundForward size={30} className="visit-arrow" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    flexDirection: "column",
    justifyContent: "center",
  },
  line: {
    width: "25px",
    height: "1px",
    backgroundColor: "#1CC587",
    transform: "rotate(-150deg)",
    margin: "5px ",
  },
};

export default VisitUs;
